<template>
	<div class="content-box">
		<h3 class="text-center mb-3">{{info.type.name}}</h3>
		<info-table
			ref="baseInfoTable"
			data-model-name="Transaction"
			:record-id="recordId"
			:fields="infoFields"
			:auto-load="false"
		></info-table>
		<div v-if="userPrivilegeMapping[59]">总价：{{info.total_price}}</div>
	</div>
</template>

<script>
import TxOp from "@/mixinsApp/TxOp.js";
import TxInfo from "@/mixinsApp/TxInfo.js";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	mixins: [TxInfo, TxOp],
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	data() {
		return {
			infoFields: [
				[
					{
						name: "warehouse",
						col: 2,
					},
					{
						name: "supplier",
						col: 2,
					},
					{
						name: "show_id",
						col: 2,
					},
					{
						name: "tx_at",
						params: {
							type: "date",
						},
						col: 2,
					},
					{
						name: "verify_at",
						params: {
							type: "date",
						},
						col: 2,
					},
				],
				[
					{
						name: "discount",
						col: 2,
					},
					{
						name: "express_fee",
						col: 2,
					},
				],
				[
					{
						name: "desc",
						col: 12,
					},
				],
			],
		};
	},
};
</script>
